<template lang='pug' src='./Login.pug'></template>

<script>
  import GoogleBtn from '../../components/GoogleBtn/GoogleBtn'

  export default {
    name: 'Login',
    components: {
      GoogleBtn
    }
  }
</script>

<style lang='css' src='./Login.css'></style>



// WEBPACK FOOTER //
// Login.vue?62a6f1e4